import { applyMiddleware, compose, createStore } from "redux";
import createSaga from "redux-saga";
import RootReducer from "./reducers";
import sagas from "./sagas";

const sagaMiddleware = createSaga();

const RootStore = createStore(
  RootReducer,
  compose(
    applyMiddleware(sagaMiddleware)
  )
);
export default RootStore;

sagaMiddleware.run(sagas);